<ion-label class="label" position="floating">Trip Options</ion-label>
<div class="items" id="gambys" #gambys>
  <div
    class="block"
    *ngFor="let option of optionsItem; let i = index"
    id="{{ 'gambys' + i }}"
    [ngClass]="{ selected: i === selected || (i === 2 && option.selected) }"
    (click)="setOption(option, i)"
  >
    <div class="chip">
      <span *ngIf="option.value === 2">Schedule</span>
      <ion-label color="secondary" *ngIf="option.value !== 2">
        {{ option.label }}
      </ion-label>
    </div>
  </div>
</div>

<ion-modal
  [keepContentsMounted]="true"
  size="auto"
  side="top"
  [cssClass]="'bottom-end'"
>
  <ion-datetime
    #dateTime
    [showDefaultButtons]="true"
    presentation="date-time"
    preferWheel="true"
    size="cover"
    locale="en-US"
    alignment="end"
    backdropDismiss="false"
    [min]="dateNow | date: 'yyyy-MM-ddThh:mm:ss'"
    hourValues="12,1,2,3,4,5,6,7,8,9,10,11,12"
    [showDefaultTitle]="true"
    [max]="maxDate | date: 'yyyy-MM-dd'"
    *ngIf="selected === 2 && checkEnabledDate"
    (ionChange)="emitDate($event)"
  >
    <ion-datetime>
      <span slot="title">Schedule a Trip Date</span>
    </ion-datetime>
  </ion-datetime>
</ion-modal>
